<template>
  <Carousel class="productCarousel" :autoplay="true" >
    <Slide v-for="item in items" :key="item.id"> <ListItem :carousel="true" :item="item"/></Slide>
  </Carousel>
</template>

<script>
// Documentation https://github.com/SSENSE/vue-carousel
import { Slide } from "vue-carousel";
import Carousel from '../carousel/Carousel'

import ListItem from "@/sections/shop/listing/ListItem"

export default {
  name:"ProductCarousel",
  components: {
    Slide,
    Carousel,
    ListItem
  },
  props: [
    "items", "autoplay"
  ]
};
</script>


<style lang="scss" scoped>
.productCarousel{
  border: 5px solid $CTred;
}

</style>
